import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar/AppBar';
import IconButton from '@mui/material/IconButton';
import { MenuIcon } from '@heroicons/react/outline';

import { withQueryParams } from '@shared/commonFunctions';
import { ReactComponent as PhxLogo } from '@svg/img-phx-logo.svg';
import { AppBar, ControlsGroup, HeaderToolbar, LogoGroup, PhxLogoWrapper, SearchGroup } from '@styles/Layout/HeaderStyles';
import { useTabs } from '@shared/hooks/useTabs';
import { SearchInput } from './components/SearchInput';
import { HeaderControls } from './components/HeaderControls';

interface IHeaderOwnProps {
  open: boolean;
  toggleDrawer: () => void;
}

export interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

export const LAYOUT_HEADER_HEIGHT = 80;

export const Header = ({ open, toggleDrawer }: IHeaderOwnProps) => {
  const navigate = useNavigate();
  const { openTab } = useTabs();

  const makeSearchRequest = useCallback(
    (value: string) => {
      const curRoute = `${location.pathname.toString()}${location.search}`;
      const route = withQueryParams('/search-results', { searchText: value?.trim() }, false);
      const title = 'Search Results';
      openTab({ title, route, replaceIfNotExist: curRoute.includes('search-results') });
      navigate(route);
    },
    []
  );
  
  return (
    <AppBar elevation={0} position="relative" open={open}>
      <HeaderToolbar>
        <LogoGroup>
          <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={toggleDrawer}>
            <MenuIcon width={24} color="#5C5C5C" />
          </IconButton>

          <PhxLogoWrapper>
            <PhxLogo onClick={() => navigate('/')} />
          </PhxLogoWrapper>
        </LogoGroup>

        <SearchGroup>
          <SearchInput placeholder="Search: Contacts, Leads, Deal No. etc." onSearch={makeSearchRequest} />
        </SearchGroup>

        <ControlsGroup>
          <HeaderControls />
        </ControlsGroup>
      </HeaderToolbar>
    </AppBar>
  );
};
